module.exports = __webpack_public_path__ + "static/media/selfie.3ea25dd1.svg";